module.exports = __webpack_public_path__ + "media/images/new-ui-images/dot-action-ffb58b3720220842fad56fccac20a3aa.svg";